// extracted by mini-css-extract-plugin
export default {"datalist":"DatalistInput_datalist__9Ela0"};